import request from '@/utils/request'

// 分页查询
export function workProjectPage(params) {
  return request({
    url: '/workProject/page',
    method: 'get',
    params
  })
}
// 查询详情
export function findById(params) {
  return request({
    url: '/workProject/findById',
    method: 'get',
    params
  })
}
// 新增
export function workProjectSave(data) {
  return request({
    url: '/workProject/save',
    method: 'post',
    data
  })
}
// 删除工程
export function getdelete(params) {
  return request({
    url: '/workProject/delete',
    method: 'get',
    params
  })
}
// 终止工程
export function getStop(params) {
  return request({
    url: '/workProject/stop',
    method: 'get',
    params
  })
}
// 查询工程相关的施工队
export function findTeamsById(params) {
  return request({
    url: '/workProject/findTeamsById',
    method: 'get',
    params
  })
}
// 工程派工
export function configTeams(data) {
  return request({
    url: '/workProject/configTeams',
    method: 'post',
    data
  })
}
// 验收设置
export function checkConfig(data) {
  return request({
    url: '/workProject/checkConfig',
    method: 'post',
    data
  })
}

// 工程列表工程验收
export function projectAcceptance(params) {
  return request({
    url: '/acceptance/projectAcceptance',
    method: 'get',
    params
  })
}
// 确认竣工
export function finishProject(params) {
  return request({
    url: '/workProject/finishProject',
    method: 'get',
    params
  })
}
export function workDesignSave(data) {
  return request.post('/workDesign/save', data)
}

export function designFindById(params) {
  return request.get('/workDesign/findById', { params })
}

export function materialSave(params) {
  return request.post('/workMaterial/save', params)
}

export function materialFindById(params) {
  return request.get('/workMaterial/findDetailsById', { params })
}

export function updateManager(data) {
  return request.post('/workProject/updateManager', data)
}

export function workStartDetail(params) {
  return request.get('/workStart/findByProjectId', { params })
}

export function checkPointDetail(params) {
  return request.get('/workCheckPoint/findById', { params })
}

export function materialDetailAll(params) {
  return request.get('/workMaterial/findById', { params })
}

export function materialListByPro(params) {
  return request.get('/workMaterial/findOrdersByProjectId', { params })
}

export function materialFindByBusinessId(params) {
  return request.get('/workMaterial/findByBusinessId', { params })
}

export function workSurveyDetail(params) {
  return request.get('/workSurvey/findByProjectId', { params })
}

export function importMaterials(data, query) {
  let url = `/workMaterial/importMaterials?materialType=${query.materialType}&projectId=${query.projectId}`
  return request.post(url, data)
}

export function workDesignUpdate(data) {
  return request.post('/workDesign/designUpdate', data)
}

export default {
  workDesignUpdate,
  workProjectPage,
  findById,
  workProjectSave,
  findTeamsById,
  configTeams,
  checkConfig,
  workDesignSave,
  designFindById,
  materialSave,
  materialFindById,
  updateManager,
  workStartDetail,
  checkPointDetail,
  materialDetailAll,
  materialListByPro,
  materialFindByBusinessId,
  workSurveyDetail,
  projectAcceptance,
  finishProject,

  importMaterials,
  technicalDetailById(params) {
    return request.get('/workTechTransition/findById', { params })
  },

  loadApplyList(params) {
    return request.get('/applyFor/selectApplyForList', { params })
  },

  loadReturnList(params) {
    return request.get('/materialUseReturn/page', { params })
  },

  orderApplyDetail(params) {
    return request.get('/applyFor/materialMrpExecute', { params })
  },

  orderReturnDetail(params) {
    return request.get('/materialUseReturn/findById', { params })
  }
}
